import { call, put, takeLatest, debounce } from 'redux-saga/effects';
import {
    getOrder,
    createOrder,
    updateOrder,
    createProductSnapshot,
    updateProductSnapshot,
    deleteProductSnapshot,
    searchOrders,
    updateOrderStatus,
    downloadProformaInvoice,
} from '../../../services/order/order-service';
import {
    GET_ORDER_REQUEST,
    getOrderSuccess,
    getOrderFailure,
    CREATE_ORDER_REQUEST,
    createOrderSuccess,
    createOrderFailure,
    UPDATE_ORDER_REQUEST,
    updateOrderSuccess,
    updateOrderFailure,
    CREATE_PRODUCT_SNAPSHOT_REQUEST,
    createProductSnapshotSuccess,
    createProductSnapshotFailure,
    UPDATE_PRODUCT_SNAPSHOT_REQUEST,
    updateProductSnapshotSuccess,
    updateProductSnapshotFailure,
    SEARCH_ORDER_SUCCESS,
    SEARCH_ORDER_FAILURE,
    SEARCH_ORDER_REQUEST,
    RESET_ORDER_STATE,
    updateOrderStatusFailure,
    updateOrderStatusSuccess,
    UPDATE_ORDER_STATUS_REQUEST,
    DOWNLOAD_ORDER_PDF_FAILURE,
    DOWNLOAD_ORDER_PDF_REQUEST,
    DELETE_PRODUCT_SNAPSHOT_REQUEST,
    deleteProductSnapshotSuccess,
    deleteProductSnapshotFailure,
} from '../actions/order-actions';

// Saga: Get Order by ID
function* getOrderSaga(action) {
    try {
        const { id } = action.payload;
        const order = yield call(getOrder, id);
        yield put(getOrderSuccess(order));
    } catch (error) {
        yield put(getOrderFailure(error));
    }
}

// Saga: Create Order (fetches or creates a draft order)
function* createOrderSaga() {
    try {
        const order = yield call(createOrder);
        yield put(createOrderSuccess(order));
    } catch (error) {
        yield put(createOrderFailure(error));
    }
}

// Saga: Update Order (only discount and customer)
function* updateOrderSaga(action) {
    try {
        const { id, updateData } = action.payload;
        const order = yield call(updateOrder, id, updateData);
        yield put(updateOrderSuccess(order));
    } catch (error) {
        yield put(updateOrderFailure(error));
    }
}


function* updateOrderStatusSaga(action) {
    try {
        const { id, orderStatus } = action.payload;
        const order = yield call(updateOrderStatus, id, orderStatus);
        yield put(updateOrderStatusSuccess(order));
    } catch (error) {
        yield put(updateOrderStatusFailure(error));
    }
}



// Saga: Create Product Snapshot for an Order
function* createProductSnapshotSaga(action) {
    try {
        const { orderId, snapshotData } = action.payload;
        // Call the POST endpoint for creating a product snapshot
        const order = yield call(createProductSnapshot, orderId, snapshotData);
        yield put(createProductSnapshotSuccess(order));
    } catch (error) {
        yield put(createProductSnapshotFailure(error));
    }
}

// Saga to handle updating a product snapshot.
function* updateProductSnapshotSaga(action) {
    try {
        const productSnapshotData = action.payload;
       const order = yield call(updateProductSnapshot, productSnapshotData);
        yield put(updateProductSnapshotSuccess(order));
    } catch (error) {
        yield put(updateProductSnapshotFailure(error));
    }
}

function* searchOrderSaga(action) {
    try {
        const { searchParams, pageable } = action.payload;
        const result = yield call(searchOrders, searchParams, pageable);
        yield put({ type: SEARCH_ORDER_SUCCESS, payload: result });
    } catch (error) {
        yield put({ type: SEARCH_ORDER_FAILURE, payload: error });
    }
}


/* <<<<<<<<<<<<<<  ✨ Windsurf Command 🌟 >>>>>>>>>>>>>>>> */
// Saga: Reset Order State (optional side-effect, e.g., logging)
function* resetOrderStateSaga(action) {
    yield put({ type: RESET_ORDER_STATE, payload: { order: null } });
    // Optionally perform any cleanup here
    // For now, there's no asynchronous work needed.
    // e.g., console.log("Order state has been reset");
}
/* <<<<<<<<<<  3c79ffcd-81ef-4f72-a288-9512e8c7635d  >>>>>>>>>>> */



function* handleDownloadOrderPdf(action) {
    try {
        yield call(downloadProformaInvoice, action.payload);
    } catch (err) {
        yield put({ type: DOWNLOAD_ORDER_PDF_FAILURE, payload: err });
    }
}

function* deleteProductSnapshotSaga({ payload }) {
    try {
        const { orderId, snapshotId } = payload;
        yield call(deleteProductSnapshot, orderId, snapshotId);
        yield put(deleteProductSnapshotSuccess(snapshotId));
    } catch (error) {
        yield put(deleteProductSnapshotFailure(error));
    }
}

// Root order saga
export default function* orderSaga() {
    yield takeLatest(GET_ORDER_REQUEST, getOrderSaga);
    yield takeLatest(CREATE_ORDER_REQUEST, createOrderSaga);
    yield takeLatest(UPDATE_ORDER_REQUEST, updateOrderSaga);
    yield takeLatest(CREATE_PRODUCT_SNAPSHOT_REQUEST, createProductSnapshotSaga);
    yield debounce(500, UPDATE_PRODUCT_SNAPSHOT_REQUEST, updateProductSnapshotSaga);
    yield takeLatest(SEARCH_ORDER_REQUEST, searchOrderSaga);
    yield takeLatest(RESET_ORDER_STATE, resetOrderStateSaga);
    yield takeLatest(UPDATE_ORDER_STATUS_REQUEST, updateOrderStatusSaga);
    yield takeLatest(DOWNLOAD_ORDER_PDF_REQUEST, handleDownloadOrderPdf);
    yield takeLatest(DELETE_PRODUCT_SNAPSHOT_REQUEST, deleteProductSnapshotSaga);
}
